import React from 'react';
import { HeaderTabs } from '@raisin/components-lib';
import { DBSProduct } from 'types';
import { OfferDetailTab } from '../types';
import BankOffersDetailTabPanel from './BankOffersDetailTabPanel';
import * as S from './styles';

export interface BankOffersDetailTabsProps {
  tabs: OfferDetailTab[];
  offer: DBSProduct;
}

export const BankOffersDetailTabs: React.FC<BankOffersDetailTabsProps> = ({ tabs, offer }) => {
  const tabsConfig = tabs.map((tab) => ({
    label: tab.title,
    id: tab.id,
    content: <BankOffersDetailTabPanel fields={tab.fields} offer={offer} tabId={tab.id} />,
  }));

  return (
    <S.HeaderTabsContainer sx={{ p: { xs: 4, sm: 6 } }} data-testid="bank-offers-detail">
      <HeaderTabs tabs={tabsConfig} />
    </S.HeaderTabsContainer>
  );
};

export default BankOffersDetailTabs;
